import React, { useEffect, useState } from "react";
import NftCard from "../../components/nft-card";
import PML from "../../images/PML_Logo.png";
import { NFTCollectionsList } from "../../api/methods-marketplace";
import NftCardLoader from "../../components/nft-card/nft-card-loader";

const CardCollection = ({ productRef }) => {
  const [cardCollection, setCardCollection] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleCardCollection = async () => {
    setIsLoading(true);
    try {
      const result = await NFTCollectionsList();
      if (result) {
        let filteredData = result?.data?.data?.filter((item) => {
          const price = item?.resale_price ?? item?.instant_sale_price;
          return price >= 1;
        });

        setCardCollection(filteredData);
        setIsLoading(false);
      }
    } catch (err) {
      console.log("🚀 ~ handleCardCollection ~ err:", err);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleCardCollection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={productRef} className="bg-white-900 pt-4 mb-24">
      <div className="max-w-7xl mx-auto px-2 space-y-4">
        <div className="section-title flex flex-col gap-2.5 mb-6">
          {/* <img className="h-[auto] w-[15.625rem]" src={PML} alt="PML_logo" /> */}
          <h1 className="text-2xl sm:text-4xl font-semibold font-bruno tracking-[0.3rem] text-black">
            PRODUCTS
          </h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {isLoading
            ? [...Array(8)].map((_, index) => <NftCardLoader key={index} />)
            : cardCollection.map((collection, index) => (
                <NftCard key={index} data={collection} />
              ))}
        </div>
      </div>
    </div>
  );
};

export default CardCollection;
